<adapt-activity-feed #organisationActivityFeed
                     [promiseToGetInitialActivity]="promiseToGetInitialOrganisationActivity"
                     [promiseToGetOlderActivity]="promiseToGetOlderOrganisationActivity"
                     [promiseToGetNewerActivity]="promiseToGetNewerOrganisationActivity"
                     emptyFeedText="There is no organisation activity to display."
                     feedTitle="">
</adapt-activity-feed>
